import request from '@/utils/request'

let Import_export_manageApi = {

  /*进出口管理列表*/
  list(data) {
    return request._post('/shop/plus.import_export_manage.Index/index', data);
},
audit(data) {
    return request._post('/shop/plus.import_export_manage.Index/audit', data);
},
/*添加进出口管理*/
add(data) {
    return request._post('/shop/plus.import_export_manage.Index/add', data);
},
/*修改进出口管理*/
edit(data) {
    return request._post('/shop/plus.import_export_manage.Index/edit', data);
},
/*删除进出口管理*/
del(data) {
    return request._post('/shop/plus.import_export_manage.Index/del', data);
},
/*进出口管理详情*/
detail(data) {
  return request._post('/shop/plus.import_export_manage.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.import_export_manage.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.import_export_manage.Setting/getSetting', data, errorback);
    },
}
export default Import_export_manageApi;



// WEBPACK FOOTER //
// ./src/api/import_export_manage.js